module.exports = __webpack_public_path__ + "static/media/idlepage-bcards.7be58ce6.svg";